export type GetCmmdRuntimeInventoryParams =
  | {
      readonly projectId: number;
      readonly allWorkspaces?: never;
      readonly organizationId?: never;
    }
  | {
      readonly projectId?: never;
      readonly allWorkspaces: true;
      readonly organizationId?: never;
    }
  | {
      readonly projectId?: never;
      readonly allWorkspaces?: never;
      /**
       * Scopes CMMD's default branch (neither `projectId` nor `allWorkspaces`)
       * to this organization, via `?orgId=` -> `X-Organization-ID`
       * (CMMD-Center/forge#3572). Omitted, CMMD falls back to the caller's
       * default workspace — usually not the one being scoped to.
       */
      readonly organizationId?: number;
    };

export function buildRuntimeInventoryQuery(
  params: GetCmmdRuntimeInventoryParams | undefined,
): Record<string, string> {
  return {
    ...(params?.projectId !== undefined ? { projectId: String(params.projectId) } : {}),
    ...(params?.allWorkspaces === true ? { allWorkspaces: "true" } : {}),
    ...(params?.organizationId !== undefined ? { orgId: String(params.organizationId) } : {}),
  };
}
